import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { useRanks } from "../Rank/hooks/use-ranks";

interface Props {
    level: string;
    setLevel: (value: string) => void;
    status: string;
    setStatus: (value: string) => void;
    rank: string;
    setRank: (value: string) => void;
    search: string;
    setSearch: (value: string) => void;
    month: string;
    setMonth: (value: string) => void;
    year: string;
    setYear: (value: string) => void;
    onSearch: () => void;
    onGenerateExcel: () => void;
}

const ExportFilters = ({
    level,
    setLevel,
    status,
    setStatus,
    rank,
    setRank,
    search,
    setSearch,
    month,
    setMonth,
    year,
    setYear,
    onSearch,
    onGenerateExcel
}: Props) => {
    const { ranks } = useRanks();
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = String(now.getMonth() + 1).padStart(2, "0");

    return (
        <Card
            className="border-0 rounded-4 p-4 h-100"
            style={{
                background: "#0d1117",
                color: "#fff"
            }}
        >
            <h5 className="fw-bold mb-4">
                1. Filtros de exportación
            </h5>

            <Row className="mb-4">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label
                            className="small mb-2"
                            style={{ color: "#9ca3af" }}
                        >
                            Buscar usuario
                        </Form.Label>

                        <Form.Control
                            type="text"
                            placeholder="Nombre o código"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                                height: "52px",
                                borderRadius: "14px",
                                background: "#161b22",
                                border: "1px solid #30363d",
                                color: "#fff"
                            }}
                        />
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label
                            className="small mb-2"
                            style={{ color: "#9ca3af" }}
                        >
                            Nivel
                        </Form.Label>

                        <Form.Select
                            value={level}
                            onChange={(e) => setLevel(e.target.value)}
                            style={{
                                height: "52px",
                                borderRadius: "14px"
                            }}
                        >
                            <option value="">Todos los niveles</option>
                            <option value="1">Nivel 1</option>
                            <option value="2">Nivel 2</option>
                            <option value="3">Nivel 3</option>
                            <option value="4">Nivel 4</option>
                            <option value="5">Nivel 5</option>
                            <option value="6">Nivel 6</option>
                            <option value="7">Nivel 7</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label
                            className="small mb-2"
                            style={{ color: "#9ca3af" }}
                        >
                            Estado
                        </Form.Label>

                        <Form.Select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{
                                height: "52px",
                                borderRadius: "14px"
                            }}
                        >
                            <option value="">Todos los estados</option>
                            <option value="active">Activos</option>
                            <option value="inactive">Inactivos</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Row className="g-3 mb-3">
                <Col md={4}>
                    <Form.Group className="mb-4">
                        <Form.Label
                            className="small mb-2"
                            style={{ color: "#9ca3af" }}
                        >
                            Rango
                        </Form.Label>

                        <Form.Select
                            value={rank}
                            onChange={(e) => setRank(e.target.value)}
                            style={{
                                height: "52px",
                                borderRadius: "14px"
                            }}
                        >
                            <option value="">Todos los rangos</option>
                            {ranks.map(rank => {
                                return <option value={rank.name}>{rank.name}</option>
                            })}

                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group className="mb-4">
                        <Form.Label
                            className="small mb-2"
                            style={{ color: "#9ca3af" }}
                        >
                            Fecha
                        </Form.Label>

                        <Form.Control
                            type="month"
                            value={`${year}-${month.padStart(2, "0")}`}
                            min={`${currentYear}-01`}
                            max={`${currentYear}-${currentMonth}`}
                            onChange={(e) => {
                                const value = e.target.value;

                                if (value) {
                                    const [yearValue, monthValue] = value.split("-");

                                    setYear(yearValue);
                                    setMonth(monthValue);
                                } else {
                                    setYear("");
                                    setMonth("");
                                }
                            }}
                            style={{
                                height: "52px",
                                borderRadius: "14px",
                                background: "#161b22",
                                border: "1px solid #30363d",
                                color: "#fff"
                            }}
                        />
                    </Form.Group>

                </Col>
            </Row>

            <div className="d-flex gap-2">
                <Button
              
                    style={{
                        background:'#3DB82D',
                        border: '1px solid #3DB82D'
                    }}
                    onClick={onSearch}
                >
                    Buscar
                </Button>

                <Button

                    variant="outline-light"
                    onClick={onGenerateExcel}
                >
                    Generar Excel
                </Button>
            </div>
        </Card>
    );
};

export default ExportFilters;